export const STATUS_MODES = {
  DOWNLOAD: "DOWNLOAD",
  CHECK: "CHECK",
  PREPARE: "PREPARE",
  UPLOAD: "UPLOAD"
}
